// import { Container, Row, Col, Form, Button } from "react-bootstrap"
// import "../components/styles/Contactsec.css"

// function Contact() {
//   return (
//     <section id="contact" className="contact-section">
//       <Container>
//         <Row>
//           <Col lg={6} className="contact-form-col">
//             <div className="contact-form-container">
//               <h2 className="contact-title">Contact with us</h2>
//               <div className="divider mb-4"></div>

//               <Form>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Name</Form.Label>
//                   <Form.Control type="text" placeholder="Your Name" />
//                 </Form.Group>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Email</Form.Label>
//                       <Form.Control type="email" placeholder="Your Email" />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Phone</Form.Label>
//                       <Form.Control type="tel" placeholder="Your Phone" />
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Message</Form.Label>
//                   <Form.Control as="textarea" rows={5} placeholder="Your Message" />
//                 </Form.Group>

//                 <Button variant="primary" type="submit" className="send-btn">
//                   Send
//                 </Button>
//               </Form>
//             </div>
//           </Col>

//           <Col lg={6} className="contact-info-col">
//             <div className="contact-info-container">
//               <h2 className="contact-title">Empower Your Business with Cutting-Edge IT Solutions!</h2>
//               <p className="contact-description">
//                 Transform your IT infrastructure with reliable, cost-effective services tailored to your needs. Connect
//                 with us today and drive growth, enhance security, and streamline operations.
//               </p>
//               <Button variant="danger" className="contact-us-btn">
//                 Contact Us
//               </Button>

//               <div className="contact-cta">
//                 <h3 className="cta-title">
//                   <span className="rocket-icon">🚀</span> Let's Build Your Future Together – Contact Us Now!
//                 </h3>
//                 <div className="contact-phone">+91 44 4854 2020</div>
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   )
// }

// export default Contact
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "../components/styles/Contactsec.css";

function Contact() {
  return (
    <section id="contact" className="contact-section">
      <Container>
        <Row>
          <Col lg={6} className="contact-form-col">
            <div className="contact-form-container">
              <h2 className="contact-title">Get in Touch for Housekeeping Services</h2>
              <div className="divider mb-4"></div>

              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text" placeholder="Your Name" />
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="email" placeholder="Your Email" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control type="tel" placeholder="Your Phone" />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control as="textarea" rows={5} placeholder="Tell us about your housekeeping needs..." />
                </Form.Group>

                <Button variant="primary" type="submit" className="send-btn">
                  Send Inquiry
                </Button>
              </Form>
            </div>
          </Col>

          <Col lg={6} className="contact-info-col">
            <div className="contact-info-container">
              <h2 className="contact-title">Reliable Housekeeping Solutions for Your Projects</h2>
              <p className="contact-description">
                We provide top-quality housekeeping services for residential, commercial, and industrial projects.
                Whether you need regular maintenance or one-time deep cleaning, our team is ready to help. 
                Contact us today to discuss your project requirements.
              </p>
              <Button variant="danger" className="contact-us-btn m-3">
                Contact Us
              </Button>

              <div className="contact-cta">
                <h3 className="cta-title">
                  <span className="rocket-icon">🧹</span> Experience Clean & Safe Spaces – Contact Us Now!
                </h3>
                <div className="contact-phone">+91 86085 98089</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Contact;

